import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

const useStyles = makeStyles(theme => ({
  stepper: {
    padding: 0,
    paddingBottom: theme.spacing(2),
  }
}));

const SignUpAndBuy = ({ steps, step, }) => {
  const classes = useStyles();
  return (
    <div>
      <Stepper activeStep={step} className={classes.stepper}>
        {steps.map((step, index) => {
          const stepProps = {};
          const labelProps = {};
          if (step.caption) {
            labelProps.optional = <Typography variant="caption">{step.caption}</Typography>;
          }
          return (
            <Step key={step.id} {...stepProps}>
              <StepLabel {...labelProps}>{step.label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}

export default SignUpAndBuy;